export const encodeURLFragment = input => {
	return encodeURIComponent(input).replace("'", "%27");
};
